import { render, staticRenderFns } from "./BitQParchi.vue?vue&type=template&id=7d726b69&scoped=true"
import script from "./BitQParchi.vue?vue&type=script&lang=js"
export * from "./BitQParchi.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7d726b69",
  null
  
)

export default component.exports